/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * Controller for the user management page.
 */
angular.module('nsadmin').controller('userManagementController', ['$scope', '$injector',
    function userManagementController($scope, $injector) {

        var userAssignmentService = $injector.get('userAssignmentService');
        var labService = $injector.get('labService');
        var podService = $injector.get('podService');
        var $location = $injector.get('$location');

        /**
         * Current active tab.
         */
        $scope.activeTab = 'userLabs';

        /**
         * All labs in the system.
         */
        $scope.labs = [];

        /**
         * All pods in the system.
         */
        $scope.pods = [];

        /**
         * User-lab assignments.
         */
        $scope.userLabAssignments = [];

        /**
         * User-pod assignments.
         */
        $scope.userPodAssignments = [];

        /**
         * Group-lab mappings.
         */
        $scope.groupLabMappings = [];

        /**
         * Group-pod mappings.
         */
        $scope.groupPodMappings = [];

        /**
         * Azure AD groups.
         */
        $scope.azureGroups = [];

        /**
         * New user-lab assignment form data.
         */
        $scope.newUserLabAssignment = {
            user_email: '',
            lab_id: ''
        };

        /**
         * New user-pod assignment form data.
         */
        $scope.newUserPodAssignment = {
            user_email: '',
            pod_id: ''
        };

        /**
         * New group-lab mapping form data.
         */
        $scope.newGroupLabMapping = {
            group_id: '',
            lab_id: ''
        };

        /**
         * New group-pod mapping form data.
         */
        $scope.newGroupPodMapping = {
            group_id: '',
            pod_id: ''
        };

        /**
         * Azure AD group member management.
         */
        $scope.groupMemberManagement = {
            selected_group_id: '',
            members: [],
            search_term: '',
            search_results: []
        };

        /**
         * Loading states.
         */
        $scope.loading = {
            labs: true,
            pods: true,
            userLabAssignments: true,
            userPodAssignments: true,
            groupLabMappings: true,
            groupPodMappings: true,
            azureGroups: true,
            groupMembers: false,
            searchUsers: false
        };

        /**
         * Error messages.
         */
        $scope.errors = {};

        /**
         * Success message.
         */
        $scope.successMessage = null;

        /**
         * Loads all labs.
         */
        function loadLabs() {
            $scope.loading.labs = true;
            labService.getAllLabs()
                .then(function success(labs) {
                    $scope.labs = labs;
                    $scope.loading.labs = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading labs:', err);
                    $scope.loading.labs = false;
                });
        }

        /**
         * Loads all pods.
         */
        function loadPods() {
            $scope.loading.pods = true;
            podService.getAllPods()
                .then(function success(pods) {
                    $scope.pods = pods;
                    $scope.loading.pods = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading pods:', err);
                    $scope.loading.pods = false;
                });
        }

        /**
         * Loads user-lab assignments.
         */
        function loadUserLabAssignments() {
            $scope.loading.userLabAssignments = true;
            userAssignmentService.getUserLabAssignments()
                .then(function success(assignments) {
                    $scope.userLabAssignments = assignments;
                    $scope.loading.userLabAssignments = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading user-lab assignments:', err);
                    $scope.loading.userLabAssignments = false;
                });
        }

        /**
         * Loads user-pod assignments.
         */
        function loadUserPodAssignments() {
            $scope.loading.userPodAssignments = true;
            userAssignmentService.getUserPodAssignments()
                .then(function success(assignments) {
                    $scope.userPodAssignments = assignments;
                    $scope.loading.userPodAssignments = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading user-pod assignments:', err);
                    $scope.loading.userPodAssignments = false;
                });
        }

        /**
         * Loads group-lab mappings.
         */
        function loadGroupLabMappings() {
            $scope.loading.groupLabMappings = true;
            userAssignmentService.getGroupLabMappings()
                .then(function success(mappings) {
                    $scope.groupLabMappings = mappings;
                    $scope.loading.groupLabMappings = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading group-lab mappings:', err);
                    $scope.loading.groupLabMappings = false;
                });
        }

        /**
         * Loads group-pod mappings.
         */
        function loadGroupPodMappings() {
            $scope.loading.groupPodMappings = true;
            userAssignmentService.getGroupPodMappings()
                .then(function success(mappings) {
                    $scope.groupPodMappings = mappings;
                    $scope.loading.groupPodMappings = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading group-pod mappings:', err);
                    $scope.loading.groupPodMappings = false;
                });
        }

        /**
         * Loads Azure AD groups.
         */
        function loadAzureGroups() {
            $scope.loading.azureGroups = true;
            userAssignmentService.getAzureAdGroups()
                .then(function success(groups) {
                    $scope.azureGroups = groups;
                    $scope.loading.azureGroups = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading Azure AD groups:', err);
                    $scope.loading.azureGroups = false;
                });
        }

        /**
         * Assigns a user to a lab.
         */
        $scope.assignUserToLab = function assignUserToLab() {
            $scope.errors.assignUserLab = null;
            $scope.successMessage = null;

            if (!$scope.newUserLabAssignment.user_email || !$scope.newUserLabAssignment.lab_id) {
                $scope.errors.assignUserLab = 'User email and lab are required';
                return;
            }

            userAssignmentService.assignUserToLab(
                $scope.newUserLabAssignment.user_email,
                $scope.newUserLabAssignment.lab_id
            )
                .then(function success() {
                    $scope.successMessage = 'User assigned to lab successfully';
                    $scope.newUserLabAssignment = { user_email: '', lab_id: '' };
                    loadUserLabAssignments();
                })
                ['catch'](function error(err) {
                    $scope.errors.assignUserLab = err.message || 'Failed to assign user to lab';
                });
        };

        /**
         * Removes a user from a lab.
         */
        $scope.removeUserFromLab = function removeUserFromLab(assignment) {
            if (!confirm('Remove user \"' + assignment.user_email + '\" from lab \"' + assignment.lab_id + '\"?')) {
                return;
            }

            $scope.successMessage = null;

            userAssignmentService.removeUserFromLab(assignment.user_email, assignment.lab_id)
                .then(function success() {
                    $scope.successMessage = 'User removed from lab successfully';
                    loadUserLabAssignments();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to remove user from lab'));
                });
        };

        /**
         * Assigns a user to a pod.
         */
        $scope.assignUserToPod = function assignUserToPod() {
            $scope.errors.assignUserPod = null;
            $scope.successMessage = null;

            if (!$scope.newUserPodAssignment.user_email || !$scope.newUserPodAssignment.pod_id) {
                $scope.errors.assignUserPod = 'User email and pod are required';
                return;
            }

            userAssignmentService.assignUserToPod(
                $scope.newUserPodAssignment.user_email,
                $scope.newUserPodAssignment.pod_id
            )
                .then(function success() {
                    $scope.successMessage = 'User assigned to pod successfully';
                    $scope.newUserPodAssignment = { user_email: '', pod_id: '' };
                    loadUserPodAssignments();
                })
                ['catch'](function error(err) {
                    $scope.errors.assignUserPod = err.message || 'Failed to assign user to pod';
                });
        };

        /**
         * Removes a user from a pod.
         */
        $scope.removeUserFromPod = function removeUserFromPod(assignment) {
            if (!confirm('Remove user \"' + assignment.user_email + '\" from pod \"' + assignment.pod_id + '\"?')) {
                return;
            }

            $scope.successMessage = null;

            userAssignmentService.removeUserFromPod(assignment.user_email, assignment.pod_id)
                .then(function success() {
                    $scope.successMessage = 'User removed from pod successfully';
                    loadUserPodAssignments();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to remove user from pod'));
                });
        };

        /**
         * Maps a group to a lab.
         */
        $scope.mapGroupToLab = function mapGroupToLab() {
            $scope.errors.mapGroupLab = null;
            $scope.successMessage = null;

            if (!$scope.newGroupLabMapping.group_id || !$scope.newGroupLabMapping.lab_id) {
                $scope.errors.mapGroupLab = 'Group and lab are required';
                return;
            }

            userAssignmentService.mapGroupToLab(
                $scope.newGroupLabMapping.group_id,
                $scope.newGroupLabMapping.lab_id
            )
                .then(function success() {
                    $scope.successMessage = 'Group mapped to lab successfully';
                    $scope.newGroupLabMapping = { group_id: '', lab_id: '' };
                    loadGroupLabMappings();
                })
                ['catch'](function error(err) {
                    $scope.errors.mapGroupLab = err.message || 'Failed to map group to lab';
                });
        };

        /**
         * Unmaps a group from a lab.
         */
        $scope.unmapGroupFromLab = function unmapGroupFromLab(mapping) {
            if (!confirm('Unmap group from lab \"' + mapping.lab_id + '\"?')) {
                return;
            }

            $scope.successMessage = null;

            userAssignmentService.unmapGroupFromLab(mapping.group_id, mapping.lab_id)
                .then(function success() {
                    $scope.successMessage = 'Group unmapped from lab successfully';
                    loadGroupLabMappings();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to unmap group from lab'));
                });
        };

        /**
         * Maps a group to a pod.
         */
        $scope.mapGroupToPod = function mapGroupToPod() {
            $scope.errors.mapGroupPod = null;
            $scope.successMessage = null;

            if (!$scope.newGroupPodMapping.group_id || !$scope.newGroupPodMapping.pod_id) {
                $scope.errors.mapGroupPod = 'Group and pod are required';
                return;
            }

            userAssignmentService.mapGroupToPod(
                $scope.newGroupPodMapping.group_id,
                $scope.newGroupPodMapping.pod_id
            )
                .then(function success() {
                    $scope.successMessage = 'Group mapped to pod successfully';
                    $scope.newGroupPodMapping = { group_id: '', pod_id: '' };
                    loadGroupPodMappings();
                })
                ['catch'](function error(err) {
                    $scope.errors.mapGroupPod = err.message || 'Failed to map group to pod';
                });
        };

        /**
         * Unmaps a group from a pod.
         */
        $scope.unmapGroupFromPod = function unmapGroupFromPod(mapping) {
            if (!confirm('Unmap group from pod \"' + mapping.pod_id + '\"?')) {
                return;
            }

            $scope.successMessage = null;

            userAssignmentService.unmapGroupFromPod(mapping.group_id, mapping.pod_id)
                .then(function success() {
                    $scope.successMessage = 'Group unmapped from pod successfully';
                    loadGroupPodMappings();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to unmap group from pod'));
                });
        };

        /**
         * Loads members of a selected Azure AD group.
         */
        $scope.loadGroupMembers = function loadGroupMembers() {
            if (!$scope.groupMemberManagement.selected_group_id) {
                return;
            }

            $scope.loading.groupMembers = true;
            $scope.groupMemberManagement.members = [];

            userAssignmentService.getGroupMembers($scope.groupMemberManagement.selected_group_id)
                .then(function success(members) {
                    $scope.groupMemberManagement.members = members;
                    $scope.loading.groupMembers = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading group members:', err);
                    $scope.loading.groupMembers = false;
                    alert('Error: ' + (err.message || 'Failed to load group members'));
                });
        };

        /**
         * Searches for Azure AD users.
         */
        $scope.searchUsers = function searchUsers() {
            if (!$scope.groupMemberManagement.search_term || $scope.groupMemberManagement.search_term.length < 3) {
                $scope.groupMemberManagement.search_results = [];
                return;
            }

            $scope.loading.searchUsers = true;

            userAssignmentService.searchAzureAdUsers($scope.groupMemberManagement.search_term)
                .then(function success(users) {
                    $scope.groupMemberManagement.search_results = users;
                    $scope.loading.searchUsers = false;
                })
                ['catch'](function error(err) {
                    console.error('Error searching users:', err);
                    $scope.loading.searchUsers = false;
                });
        };

        /**
         * Adds a user to an Azure AD group.
         */
        $scope.addUserToGroup = function addUserToGroup(user) {
            if (!$scope.groupMemberManagement.selected_group_id) {
                alert('Please select a group first');
                return;
            }

            $scope.successMessage = null;

            userAssignmentService.addUserToAzureGroup(
                $scope.groupMemberManagement.selected_group_id,
                user.id
            )
                .then(function success() {
                    $scope.successMessage = 'User added to group successfully';
                    $scope.loadGroupMembers();
                    $scope.groupMemberManagement.search_term = '';
                    $scope.groupMemberManagement.search_results = [];
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to add user to group'));
                });
        };

        /**
         * Removes a user from an Azure AD group.
         */
        $scope.removeUserFromGroup = function removeUserFromGroup(user) {
            if (!confirm('Remove user \"' + user.displayName + '\" from this group?')) {
                return;
            }

            $scope.successMessage = null;

            userAssignmentService.removeUserFromAzureGroup(
                $scope.groupMemberManagement.selected_group_id,
                user.id
            )
                .then(function success() {
                    $scope.successMessage = 'User removed from group successfully';
                    $scope.loadGroupMembers();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to remove user from group'));
                });
        };

        /**
         * Switches to a different tab.
         */
        $scope.switchTab = function switchTab(tab) {
            $scope.activeTab = tab;
            $scope.clearMessages();
        };

        /**
         * Clears success/error messages.
         */
        $scope.clearMessages = function clearMessages() {
            $scope.successMessage = null;
            $scope.errors = {};
        };

        /**
         * Navigates back to the dashboard.
         */
        $scope.goToDashboard = function goToDashboard() {
            $location.path('/nsadmin/dashboard');
        };

        /**
         * Gets the display name for a group ID.
         */
        $scope.getGroupName = function getGroupName(groupId) {
            var group = $scope.azureGroups.find(function(g) {
                return g.id === groupId;
            });
            return group ? group.displayName : groupId;
        };

        // Load data on controller initialization
        loadLabs();
        loadPods();
        loadUserLabAssignments();
        loadUserPodAssignments();
        loadGroupLabMappings();
        loadGroupPodMappings();
        loadAzureGroups();

        console.log('User Management controller loaded');
    }
]);
